import { Map } from 'immutable';
import { createReducer } from 'redux-act';

import EnableReservationsResult from '../../models/interfaces/EnableReservationsResult';
import { enableReservationsFailed, enableReservationsFinished } from '../actions/place/enableReservations';

export interface EnableReservationsState {
  readonly enableReservationsResults: Map<string, { enableReservationsResult: EnableReservationsResult; placeUniqueName?: string }>;
}

const defaultState: EnableReservationsState = {
  enableReservationsResults: Map(),
};

const enableReservationsReducer = createReducer<EnableReservationsState>({}, defaultState);

enableReservationsReducer.on(enableReservationsFinished, (state, { enableReservationsResult, token, placeUniqueName }) => {
  const { enableReservationsResults, ...others } = state;
  return { ...others, enableReservationsResults: enableReservationsResults.set(token, { enableReservationsResult, placeUniqueName }) };
});

enableReservationsReducer.on(enableReservationsFailed, (state, { enableReservationsResult, token }) => {
  const { enableReservationsResults, ...others } = state;
  return { ...others, enableReservationsResults: enableReservationsResults.set(token, { enableReservationsResult }) };
});

export default enableReservationsReducer;
